import { Dispatch, SetStateAction, useState } from 'react'
import {
  getAppraisalComments,
  getAppraisalOrderStatus,
  getAppraisalVendorDocuments,
  postAppraisal2Documents,
  postAppraisalComments,
} from 'services'
import { capitalize, formatTime } from 'utils'

import { AppraisalOrderFile, IntegrationType, integrationTypeTitles } from '../types'
import { AppraisalVendorModal } from './AppraisalVendorModal'
import { getVendorExtraTabs } from './vendorExtraTabs'

export const StandardAppraisalModal = ({
  integrationType,
  data,
  onClose,
  docTypes,
}: {
  integrationType: IntegrationType
  data: Record<string, any>
  onClose: Function
  docTypes?: string[]
}) => {
  const [status, setStatus] = useState<string | null>(null)
  const [progress, setProgress] = useState<any>(null)
  const [orderFiles, setOrderFiles] = useState<AppraisalOrderFile[]>([])

  const { appraisalID } = data.thirdPartyAPI
  const title = integrationTypeTitles[integrationType]
  const extraTabs = getVendorExtraTabs(integrationType)

  const onMount = async (setLoading: Dispatch<SetStateAction<boolean>>) => {
    setLoading(true)
    const [statusRes, vendorRes]: any[] = await Promise.all([
      getAppraisalOrderStatus(appraisalID, integrationType),
      getAppraisalVendorDocuments(data.id),
    ])
    if (statusRes.success) {
      setStatus(statusRes.data)
      setProgress(statusRes.dates)
    }
    if (vendorRes.success && vendorRes.documents?.length) {
      setOrderFiles(vendorRes.documents)
    }
    setLoading(false)
  }

  const renderProgressSection =
    status !== null ? (
      <div className="px-2">
        <div className="mb-4">
          <div className="flex flex-wrap gap-4 justify-between">
            <div>
              Status: <span className="font-bold text-shade-blue italic">{capitalize(status)}</span>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-4 mb-4">
          {progress?.map((item: any, index: number) => (
            <div className="flex w-full flex-col sm:min-w-[270px] sm:w-auto sm:flex-row sm:items-center" key={index}>
              <div className="sm:min-w-[160px]">{item.label}:</div>{' '}
              <div className="italic font-bold text-[14px]">{formatTime(item.value)}</div>
            </div>
          ))}
        </div>
      </div>
    ) : null

  return (
    <AppraisalVendorModal
      title={`${title} - ${appraisalID}`}
      data={data}
      onClose={onClose}
      fetchLogs={() => getAppraisalComments(appraisalID, integrationType)}
      postComment={(comment) => postAppraisalComments({ appraisalID, comment }, integrationType)}
      postDocuments={(id, documents) => postAppraisal2Documents({ id, documents })}
      docTypes={docTypes}
      sendMessageLabel={`Send Message to ${title}`}
      uploadDocumentsLabel={`Upload Documents to ${title}`}
      renderProgressSection={renderProgressSection}
      orderFiles={orderFiles}
      onMount={onMount}
      menuTabs={extraTabs.length ? ['Notification Logs', 'Documents', ...extraTabs.map((tab) => tab.label)] : undefined}
      renderExtraTabContent={
        extraTabs.length
          ? (menu) => extraTabs.find((tab) => tab.label === menu)?.render({ appraisalID, status, data }) ?? null
          : undefined
      }
    />
  )
}
